import { AccountEditIcon } from './AccountEditIcon';

/**
 * author: Michael Richins
 * id 66271DF7-FF11-4998-9C03-F096CE407E4C
 * name account-edit
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-edit.svg
 * tags
 * - Account / User 
 * - Edit / Modify 
 */
export const PersonEditIcon = AccountEditIcon;
export default PersonEditIcon